module.exports = __webpack_public_path__ + "static/img/38.9ad5c18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/38.png
// module id = IXpO
// module chunks = 0